import React from 'react';
import { BodyText, Logo, Box } from '@chargify/custom-ui-components';

import { FieldsLabels } from './types';

import ThreeDigit from '../ThreeDigit';
import FourDigit from '../FourDigit';
import { Row, Separator } from './TooltipContent.styles';

type TooltipContentProps = {
  /**
   * Tooltip fields labels
   */
  labels: FieldsLabels;
};

const TooltipContent = ({ labels }: TooltipContentProps) => {
  const { threeDigitTooltip, fourDigitTooltip } = labels;

  return (
    <Row>
      <Row flexDirection="column">
        <Row gridGap={3}>
          <Logo type="visa" height={8} width={25} />
          <Logo type="master" height={8} width={14} />
          <Logo type="discover" height={8} width={48} />
        </Row>
        <Box marginTop={3} marginBottom={3}>
          <ThreeDigit />
        </Box>
        <BodyText variant="body3" color="black.light">
          {threeDigitTooltip}
        </BodyText>
      </Row>
      <Separator marginLeft={3} marginRight={3} />
      <Row flexDirection="column">
        <Logo type="american_express" height={8} width={10} />
        <Box marginBottom={3} marginTop={3}>
          <FourDigit />
        </Box>
        <BodyText variant="body3" color="black.light">
          {fourDigitTooltip}
        </BodyText>
      </Row>
    </Row>
  );
};

export default TooltipContent;
